import React from 'react';
import './Banner.css';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Banner = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section className="banner-section">
      <div className="banner-card">
        <div className="banner-ellipses">
          <div className="banner-ellipse ellipse-1"></div>
          <div className="banner-ellipse ellipse-2"></div>
          <div className="banner-ellipse ellipse-3"></div>
          <div className="banner-ellipse ellipse-4"></div>
          <div className="banner-ellipse ellipse-5"></div>
          <div className="banner-ellipse ellipse-6"></div>
          <div className="banner-ellipse ellipse-7"></div>
        </div>
        <div className="banner-card-content">
          <div className="banner-card-title">
            <h2 className="banner-card-heading">{t.bannerTitle}</h2>
            <p className="banner-card-description">
              {t.bannerDescription}
            </p>
          </div>
          <a href="#contact-form" className="banner-card-button">{t.bannerButton}</a>
        </div>
      </div>
    </section>
  );
};

export default Banner;

